export default {
  name: 'SimpleRouteWrapper',
  render: (c) => {
    return c('router-view')
  }
}
